"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScrollingRootConfig = /** @class */ (function () {
    function ScrollingRootConfig() {
    }
    ScrollingRootConfig.setDefaultRootContainerId = function (defaultScrollingRootId) {
        ScrollingRootConfig.defaultScrollingRootId = defaultScrollingRootId;
    };
    ScrollingRootConfig.getDefaultRootContainer = function () {
        var defaultRootContainer = ScrollingRootConfig.defaultScrollingRootId ?
            document.getElementById(ScrollingRootConfig.defaultScrollingRootId) :
            document.body;
        if (!defaultRootContainer) {
            throw Error('Could not find scrolling root with the id scrollingRootId.');
        }
        return defaultRootContainer;
    };
    return ScrollingRootConfig;
}());
exports.ScrollingRootConfig = ScrollingRootConfig;
//# sourceMappingURL=ScrollingRoot.js.map